/**
 * EventDescriptionSection
 *
 * Description text area with task list functionality.
 * Integrates ChecklistDescriptionField for embedded tasks.
 */

import { ChecklistDescriptionField } from '@/components/shared/fields/ChecklistDescriptionField';
import { Colors } from '@/constants/theme';
import { Spacing } from '@/constants/spacing';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

type EventDescriptionSectionProps = {
  value: string;
  onChange: (value: string) => void;
  palette: typeof Colors.light;
  taskColor?: string | null;
  onTaskColorChanged?: (color: string) => void;
  onTaskToggled?: (serializedDescription: string) => void;
};

export function EventDescriptionSection({
  value,
  onChange,
  palette,
  taskColor,
  onTaskColorChanged,
  onTaskToggled,
}: EventDescriptionSectionProps) {
  const paletteTextMuted = useMemo(() => palette.textMuted ?? '#888', [palette.textMuted]);

  return (
    <View style={styles.container}>
      <ChecklistDescriptionField
        value={value}
        onChange={onChange}
        palette={palette}
        paletteTextMuted={paletteTextMuted}
        taskColor={taskColor}
        onTaskColorChanged={onTaskColorChanged}
        onTaskToggled={onTaskToggled}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.sm + 2, // 10px
  },
});
